import React from 'react';
import 'twin.macro';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import NumberInputGroup from '@teetsh/app/src/components/Form/NumberInputGroup';

interface Props {
  value: number;
  onChange: (v: number) => void;
  label: string;
  helperText?: string | React.ReactNode;
}

export function QuantitySelector({
  value,
  onChange,
  label,
  helperText,
}: Props) {
  return (
    <div tw="flex w-full items-start gap-x-4">
      <div tw="pt-[22px]">
        <Button
          onClick={() => onChange(Math.max(0, value - 1))}
          tw="rounded-lg p-2 h-10 w-10"
        >
          <MinusIcon tw="h-5 w-5" />
        </Button>
      </div>

      <div tw="flex-1 min-w-0">
        <NumberInputGroup
          withoutMargin
          label={label}
          fractionDigits={0}
          emptyValue=""
          min={0}
          max={Number.MAX_SAFE_INTEGER}
          tw="text-left w-full"
          onChange={v => onChange(v || 0)}
          value={value}
        />
        {helperText && (
          <div tw="text-muted text-sm text-right mt-1">{helperText}</div>
        )}
      </div>

      <div tw="pt-[22px]">
        <Button
          onClick={() => onChange(value + 1)}
          tw="rounded-lg p-2 h-10 w-10"
        >
          <PlusIcon tw="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
